import './lib/PST.Web.Common/src/polyfills/ie';
import './lib/PST.Web.Common/theme.scss';

import React from 'react';
import ReactDOM from 'react-dom';

import { App } from './App';

ReactDOM.render(<App />, document.getElementById('root'));
